import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { StyledIconButton } from '#component/project/form/alert-confirmation/option-item/style';

/**
 * Renders MUI Icon button to remove alert confirmation option.
 * @returns {React.FC}
 */

const OptionItemActions = ({ deleteConfirmationOption }) => (
  <StyledIconButton
    size="small"
    aria-label="Remove alert confirmation option"
    onClick={deleteConfirmationOption}
  >
    <Tooltip title="Delete alert confirmation option">
      <DeleteIcon />
    </Tooltip>
  </StyledIconButton>
);

export default OptionItemActions;
